/**
2  *  Copyright (c) 2018 Micro Focus Software Inc.  All Rights Reserved.
3  *
4  * THIS WORK IS AN UNPUBLISHED WORK AND CONTAINS CONFIDENTIAL PROPRIETARY
5  * AND TRADE SECRET INFORMATION OF MICRO FOCUS SOFTWARE INC. ACCESS  TO  THIS
6  * WORK IS RESTRICTED TO (I) MICRO FOCUS SOFTWARE INC. EMPLOYEES WHO HAVE A NEED
7  * TO  KNOW HOW TO  PERFORM  TASKS WITHIN  THE SCOPE  OF  THEIR   ASSIGNMENTS
8  * AND (II) ENTITIES OTHER  THAN  MICRO FOCUS SOFTWARE INC.  WHO  HAVE ENTERED
9  * INTO APPROPRIATE LICENSE   AGREEMENTS.  NO  PART  OF  THIS WORK MAY BE USED,
10  * PRACTICED, PERFORMED COPIED, DISTRIBUTED, REVISED, MODIFIED, TRANSLATED, ABRIDGED,
11  * CONDENSED, EXPANDED, COLLECTED, COMPILED, LINKED,  RECAST, TRANSFORMED
12  * OR ADAPTED  WITHOUT THE PRIOR WRITTEN CONSENT OF MICRO FOCUS SOFTWARE INC.
13  * ANY USE OR EXPLOITATION  OF  THIS WORK WITHOUT AUTHORIZATION COULD SUBJECT
14  * THE PERPETRATOR  TO CRIMINAL AND CIVIL LIABILITY.
15  */

import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CustomField, CustomEntryList } from '../../model/customfieldsresponse';
declare var $: any;

@Component({
  selector: 'zsd-stringfield',
  templateUrl: '../../view/customfields/stringfield.component.html',
  styleUrls: ['../../view/customfields/customfields.component.scss']
})
export class StringFieldComponent implements OnInit {
  @Input('parentForm') public parentForm: FormGroup;
  @Input() customField: CustomField;
  @Input('fromQuickCall') public fromQuickCall: boolean;


  stringInfoForm: FormGroup;
  stringValueText = '';
  required = false;
  dscEnable = false;
  description = '';
  stringFieldFocus = false;
  customerEditable = false;
  inputValidation = false;
  inputMask = '';
  userMask = '';
  tempString = '';
  stringTypeText = false;
  stringFieldListFocus = false;
  stringList: CustomEntryList[] = new Array<CustomEntryList>();

  customValidators = [];
  constructor(public formBuilder: FormBuilder) { }

  ngOnInit() {
    if (this.customField.dscEnable === 1) {
      this.dscEnable = true;
      this.description = this.customField.description;
    }

    if (this.customField.required === 1) {
      this.required = true;
      this.customValidators.push(Validators.required);
    }
    if (this.customField.clientEditable === 1) {
      this.customerEditable = true;
    }

    if (this.customField.fieldType === 1) {
      this.stringTypeText = true;
    }

    if (this.customField.inputValidation === 1) {
      this.inputValidation = true;
      this.inputMask = this.customField.inputMask;
      this.userMask = this.customField.userMask;
    }

    if (this.stringTypeText) {
      if (
        this.customField.defaultValue != null &&
        this.customField.defaultValue.length > 0
      ) {
        this.stringValueText = this.customField.defaultValue;
      }
      this.stringInfoForm = this.formBuilder.group({
        data: this.formBuilder.control(
          {
            value: '',
            disabled: !this.customerEditable
          }
        )
      });

      this.stringInfoForm.get('data').setValue(this.stringValueText);

      if (this.inputValidation) {
        let inputMasktemp = '^' + this.inputMask + '$';
        this.customValidators.push(Validators.pattern(inputMasktemp));
      }

      this.stringInfoForm
        .get('data')
        .setValidators(this.customValidators);

      this.stringInfoForm.updateValueAndValidity();

      if (this.parentForm) {
        this.parentForm.addControl(this.customField.fieldId + '', this.stringInfoForm);
      }
      this.parentForm.setControl(this.customField.fieldId + '', this.stringInfoForm);
    }

    if (!this.stringTypeText) {
      this.stringList = this.customField.customEntry;

      this.stringInfoForm = this.formBuilder.group({
        data: this.formBuilder.control(
          { value: '', disabled: !this.customerEditable },
          this.customValidators
        )
      });

      if (
        this.customField.defaultValue != null &&
        this.customField.defaultValue.length > 0
      ) {
        for (let i = 0; i < this.stringList.length; i++) {
          if (this.customField.defaultValue === this.stringList[i].name) {
            {
              this.stringInfoForm.get('data').setValue(this.stringList[i].id);
              break;
            }
          }
        }
      }

      this.stringInfoForm.updateValueAndValidity();
      if (this.parentForm) {
        this.parentForm.addControl(this.customField.fieldId + '', this.stringInfoForm);
      }
      this.parentForm.setControl(this.customField.fieldId + '', this.stringInfoForm);
    }

    // Setup for description jquery
    if (this.customField.dscEnable === 1) {
      $(document).ready(function () {
        $('[data-toggle=' + this.customField.fieldId + ']').popover();
      }.bind(this));
    }

  }

  stringValueEmpty() {
    return this.stringInfoForm.get('data').value === '';
  }

  stringValueUpdate() {
    this.stringInfoForm.get('data').setValue(this.stringValueText);
    this.stringInfoForm.updateValueAndValidity();
    this.parentForm.setControl(this.customField.fieldId + '', this.stringInfoForm);
  }

  patternMatch() {
    if (this.inputValidation) {
      this.tempString = this.stringInfoForm.get('data').value;
      let pattern = new RegExp('^' + this.inputMask + '$');
      if (pattern.test(this.tempString)) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }
  stringListEmpty() {
    return this.stringInfoForm.get('data').value === '';
  }
  trackBystring(index) {
    return index;
  }
}
